export const CUSTOMERAUTH_DETAIL_REQUEST=`CUSTOMERAUTH_DETAIL_REQUEST`;
export const CUSTOMERAUTH_DETAIL_REQUEST_ERROR=`CUSTOMERAUTH_DETAIL_REQUEST_ERROR`;
export const UPDATE_ADMIN_STATUS = 'UPDATE_ADMIN_STATUS';
export const UPDATE_ECOM_DOMAIN = 'UPDATE_ECOM_DOMAIN';
